<dynamic-form-v2
    *ngIf="!isLoading"
    entityType="sponsors"
    [formName]="title"
    [record]="sponsorRecord"
    [fields]="fields"
    [viewRoute]="viewRoute"
    [validationCallbackFunction]="validateSponsor.bind(this)"
>
</dynamic-form-v2>
